import * as React from 'react';

import {
  SelectorBaseItem,
  SelectorSize
} from 'shared/newEntities/components/Selector';
import { PopupPosition } from 'shared/entities/components/Popup';
import { TagProps } from 'shared/newEntities/components/Tag';
import Reference from 'shared/newComponents/Reference';
import {
  TypographyColor,
  TypographySize,
  TypographyWeight
} from 'shared/newEntities/components/Typography';

import SelectorBaseOptionContent from './SelectorBaseOptionContent';

import './SelectorBaseOption.modules.scss';

type Props = SelectorBaseItem & {
  onClick: () => void;
  className?: string;
  selected?: boolean;
  selectView?: 'checkbox' | 'icon';
  largeOption?: boolean; // чтобы текст опции был максимально показан
  tag?: TagProps;
  selectorSize?: SelectorSize;
  fontSize?: TypographySize;
  fontWeight?: TypographyWeight;
  fontColor?: TypographyColor;
  smallDescription?: boolean;
  hoverReferencePosition?: PopupPosition;
};

const SelectorBaseOption: React.FC<Props> = ({
  disabled,
  disabledReference,
  hoverReference,
  hoverReferencePosition,
  ...props
}: Props) => {
  const withDisabledReference = disabled && disabledReference;

  const handlePointerDown = React.useCallback((e: React.PointerEvent) => {
    e.stopPropagation();
  }, []);

  if (!hoverReference && !withDisabledReference) {
    return (
      <div styleName="selector-base-option" onPointerDown={handlePointerDown}>
        <SelectorBaseOptionContent disabled={disabled} {...props} />
      </div>
    );
  }

  return (
    <div styleName="selector-base-option">
      <Reference
        disabledOnMobile
        position={hoverReferencePosition}
        trigger={
          <div
            styleName="selector-base-option__container"
            onPointerDown={handlePointerDown}
          >
            <SelectorBaseOptionContent disabled={disabled} {...props} />
          </div>
        }
        title={disabled ? disabledReference : hoverReference}
      />
    </div>
  );
};

export default React.memo(SelectorBaseOption);
